module.exports = __webpack_public_path__ + "img/full1-min.6648d518.png";